import { render, staticRenderFns } from "./Markings.vue?vue&type=template&id=acca9dda"
import script from "./Markings.vue?vue&type=script&lang=js"
export * from "./Markings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports